import axios from '@/axios/api.request'

export const save = (form) => axios.request({
    url: '/contract/refund/info/save',
    data: form,
    method: 'post'
  })

export const remove = (id) => axios.request({
    url: `/contract/refund/info/delete/${id}`,
    method: 'delete'
  })